import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal } from "./motion";
import { GALLERY } from "../data";

const FILTERS = [
  { key: "all", label: "All Work" },
  { key: "car", label: "Cars" },
  { key: "bike", label: "Bikes" },
  { key: "boat", label: "Boats" },
];

export default function Gallery() {
  const [filter, setFilter] = useState("all");
  const items = GALLERY.filter((g) => filter === "all" || g.type === filter);

  return (
    <section id="gallery" data-testid="gallery" className="bg-[#050505] py-20 md:py-32">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <Reveal>
            <p className="text-xs tracking-[0.3em] uppercase text-[#FF3B30] mb-4">The proof</p>
            <h2 className="font-display font-bold uppercase tracking-tight text-4xl md:text-6xl leading-none">
              Recent transformations.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="flex gap-6 overflow-x-auto pb-1">
              {FILTERS.map((f) => (
                <button
                  key={f.key}
                  data-testid={`gallery-filter-${f.key}`}
                  onClick={() => setFilter(f.key)}
                  aria-label={`Filter ${f.label}`}
                  className={`font-display uppercase tracking-widest text-sm whitespace-nowrap transition-colors pb-1 border-b ${filter === f.key ? "text-white border-[#FF3B30]" : "text-zinc-500 border-transparent hover:text-white"}`}
                >
                  {f.label}
                </button>
              ))}
            </div>
          </Reveal>
        </div>

        <motion.div layout className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-px bg-zinc-800 border border-zinc-800">
          <AnimatePresence mode="popLayout">
            {items.map((g) => (
              <motion.div
                key={g.id}
                layout
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.95 }}
                transition={{ duration: 0.4 }}
                data-testid={`gallery-item-${g.id}`}
                className={`group relative overflow-hidden bg-[#0A0A0A] ${g.id % 5 === 0 ? "lg:col-span-2 lg:row-span-2" : ""}`}
              >
                <div className="aspect-square w-full h-full overflow-hidden">
                  <img src={g.image} alt={g.label} className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700" />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                  <span className="text-white text-sm font-display uppercase tracking-wide">{g.label}</span>
                </div>
                <span className="absolute top-3 left-3 text-[10px] uppercase tracking-widest text-zinc-400 bg-black/60 px-2 py-1">{g.type}</span>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
        <p className="text-zinc-600 text-xs mt-6 text-center">Placeholder gallery — real before/after shots load in on launch.</p>
      </div>
    </section>
  );
}
